<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AxN5">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="JANUARY 8: A Tone of Thanksgiving">
<h1 class="chapter2" id="pAJL"><a href="#/contents#AB_ch09" id="AB_cha09">JANUARY 8<br/> <br/> <span class="chapter2a">A Tone of Thanksgiving</span></a></h1>
<blockquote>
<p class="ext" id="pAJe"><em>I love the L<span class="smallcaps">ORD</span>, because He has heard my voice and my supplications. Because He has inclined His ear to me, therefore I will call upon Him as long as I live.</em></p>
</blockquote>
<p class="right" id="pA1b">—Psalm 116:1–2</p>
<p class="noind" id="AXJL"><span class="dcap"><b>T</b></span>ake another look at these two verses from Psalm 116. Though not one key word about gratitude—<em>thanks</em>, <em>thankfulness</em>, <em>grateful</em>—appears here, the tone of thanksgiving is unmistakable.</p>
<p id="pA-I">The proclamation “I love” implies gratitude and communicates joy. The writer celebrates the reason for this love: “Because He has heard my voice and my supplications.” The vow to “call upon Him as long as I live” also reflects this speaker’s thankfulness for the way God hears and answers.</p>
<p id="pAMQ">Even without the word <em>thanks</em>, these verses communicate gratitude. Do our lives do the same? Put differently, what do the ways we carry ourselves, speak, and communicate using facial expressions and body language suggest about our attitude toward life? Is it clear we’re grateful people?</p>
<p id="pAmgq">Consider what retooling your attitude might need. Of course the “tone” of our lives alone cannot sufficiently express our gratitude to God or to the people in our world. But when our actions indicate a thankful heart, the words we speak ring truer. Let’s express our thanks to God in every way we can.</p>
<p class="left1" id="pAq97"><em>Lord, show me how I can make a tone of thanksgiving unmistakable in my life.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter09.vue?38e96b33